<template>
  <v-autocomplete
    class="small-text-field"
    :label="label"
    :items="users"
    item-value="id"
    item-name="id"
    item-text="idname"
    :search-input.sync="name"
    @input="updateSelf"
    single-line
    :height="28"
    :hide-details="valid() == true && (error == null || error.length == 0)"
    :error-messages="valid() == true ? null : [valid()] "
    :loading="loading"
  >
  
  </v-autocomplete>
</template>

<script>
import moment from "moment";

import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true; 

export default {
  name: "SelectableDriverUserDropdownInputForNoMatch",
  props: {
    label: String,
    errorMessages: Object,
    error: String,
    driver: {
      type: Object,
      default: null,
    },
    user: {
      type: Object,
      default: null,
    }
  },
  computed: {},
  data() {
    return {
      menu: false,
      users: [],
      loading: false,
      selectedUser: null,
      name: ""
    };
  },
  watch: {
    name() {
      this.getUser(); 
    }
  },
  methods: {
    valid() {
      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    htmlForDriver(item) {
      return (
        "<p><b>" + (item.callsign == null ? item.id : item.callsign) + "&nbsp;-&nbsp;</b>" + item.name + "</p>"
      );
    },
    updateSelf(id) {
      this.$emit("update", id)
    },
    getUser() {
      var url = `${this.$store.state.apiUrl}/no_match/${(this.driver != null ? 'findUsers' : 'findDrivers')}?name=${this.name}`;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function (res) {
          vm.users = res.data;

          for (var i = 0; i < vm.users.length; i++) {
            vm.users[i].idname =
              (vm.users[i].callsign == null ? vm.users[i].id : vm.users[i].callsign) + " " + vm.users[i].name;
          }
         
        })
        .catch(function (err) {
          console.error(err);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
